import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTableModuleConfiguration } from '../data-table/datatable-module.config';
import { DeviceHistoryItem } from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceHistoryService {
  private http = inject(HttpClient);
  private configuration = inject(DataTableModuleConfiguration);

  private get baseUrl(): string {
    if (!this.configuration.apiUrls.b2b) {
      throw new Error('B2B API URL is not configured');
    }
    return `${this.configuration.apiUrls.b2b}/api`;
  }

  getSmartwatchHistory(
    deviceId: string,
    includeChildren = false,
  ): Observable<DeviceHistoryItem[]> {
    return this.http.get<DeviceHistoryItem[]>(
      `${this.baseUrl}/smartwatches/${deviceId}/history`,
      {
        params: includeChildren
          ? new HttpParams().set('includeChildren', true)
          : undefined,
      },
    );
  }

  getLightTagHistory(
    deviceId: string,
    includeChildren = false,
  ): Observable<DeviceHistoryItem[]> {
    return this.http.get<DeviceHistoryItem[]>(
      `${this.baseUrl}/light-tags/${deviceId}/history`,
      {
        params: includeChildren
          ? new HttpParams().set('includeChildren', true)
          : undefined,
      },
    );
  }

  getSwChargerHistory(deviceId: string): Observable<DeviceHistoryItem[]> {
    return this.http.get<DeviceHistoryItem[]>(
      `${this.baseUrl}/sw-chargers/${deviceId}/history`,
    );
  }
}
